<template>
  <div class="container">
    <div class="row align-center">
      <div class="col-1 align-self-center text-center text-primary">
        <MDBIcon :onclick="leftClick" type="button" icon="chevron-left" iconStyle="fas" size="1x" />
      </div>
      <div class="col-lg-5 col-10 revealreview active">
        <Review v-if="selectedReview" :review="selectedReview" />
      </div>
      <div class="col-lg-5 revealreview active d-none d-lg-block">
        <Review v-if="selectedReviewSecond" :review="selectedReviewSecond" />
      </div>
      <div class="col-1 align-self-center text-center text-primary">
        <MDBIcon :onclick="rightClick" type="button" icon="chevron-right" iconStyle="fas" size="1x" />
      </div>
    </div>
    <div class="row mt-2 mb-2" hidden>
      <div class="col align-self-center text-center text-primary">
        <span class="me-2" v-for="index in reviews.length" :key="index">
          <MDBIcon  type="button" icon="circle" iconStyle="fas" size="1x" />
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import Review from '@/components/Review.vue'
import { MDBIcon } from 'mdb-vue-ui-kit'

export default {
  name: 'ReviewsCarousel',

  components: {
    MDBIcon,
    Review
  },
  data() {
    return {
      numOfVisibleReviews: 1,
      selectedReviewIndex: 0,
      reviews: [
        {
          rev_name: "Margit",
          rev_text:"Ein großes Lob an die Firma Umzug Bayern, wir waren mit dem Umzug sehr zufrieden. Das Team war äußerst professionell, pünktlich und freundlich. Sie haben sich sorgfältig um all unsere Möbel gekümmert und haben alles gut verpackt und gesichert. Der Umzug wurde effizient organisiert und durchgeführt. Die Preise waren transparent und fair - es gab keine versteckten Kosten. Wir können die Firma Umzug Bayern jedem empfehlen, der einen stressfreien Umzug erleben möchte. Vielen Dank an das gesamte Team für die großartige Unterstützung!",
          rev_link: "https://maps.app.goo.gl/WZbxYjejpsHG4Ri56",
          rev_rating: 5,
          rev_source: "Google Bewertung"
        },
        {
          rev_name: "Johanna Lang",
          rev_text:"Wir waren wirklich sehr zufrieden mit dem ganzen Team der Umzug Bayern: Von dem Erhalt des Angebots (Fair-Preis!) bis zum Abstellen der letzten Möbelstück. Super zuverlässig, super pünktlich, schnell, freundlich und sehr sympathisch. Unsere Möbeln waren sehr gut verpackt. Alles wurde heile in die neue Wohnung gebracht. Alles war top und unkompliziert. Empfehlen? Auf jedem Fall!",
          rev_link: "https://maps.app.goo.gl/UDyYDWSyVfA6AorV9",
          rev_rating: 5,
          rev_source: "Google Bewertung"
        },
        {
          rev_name: "Olga Kessler",
          rev_text:"Alle Mitarbeiter sehr freundlich, hilfsbereit, schnell und kompetent! Ein super Team, dem man anmerkt, dass sie sehr eingespielt sind.",
          rev_link: "https://maps.app.goo.gl/5Au3KLv4SJtnYYQo6",
          rev_rating: 5,
          rev_source: "Google Bewertung"
        },
        {
          rev_name: "Heiko Vietmeier",
          rev_text:"Super Umzug, schnell und spontan und jederzeit zuverlässig. Ein tolles Team! Jederzeit gerne wieder.",
          rev_link: "https://g.co/kgs/JF8LpkS",
          rev_rating: 5,
          rev_source: "Google Bewertung"
        },
        {
          rev_name: "Björn Kroll",
          rev_text:"Top Firma - ein absolute Empfehlung von uns!! Die machen für uns schon im dritten Jahr die komplette Logistik für unseren Tollwood-Stand in München. Da werden ganz problemlos, vollkommen unkompliziert und immer mit einem netten Lächeln, mal eben so um die 30 Tonnen bewegt. Alex und sein Team sind absolute Spitzenklasse. Gruß Björn von eisstock24",
          rev_link: "https://maps.app.goo.gl/HyUrC3K5rawduSBJ9",
          rev_rating: 5,
          rev_source: "Google Bewertung"
        },
      {
          rev_name: "Silvia Razavi",
          rev_text:"Vielen Dank an die Firma Umzug Bayern. Ich bin mit der Firma in den Saarland gezogen und ich muss sagen, dass alles vom ersten Kontakt bis zum umzugsort perfekt organisiert war und alles nach Plan abgelaufen ist. Die Mitarbeiter waren sehr kompetent und freundlich und sehr hilfsbereit. Ich kann die Firma nur wärmstens weiterempfehlen!",
          rev_link: "https://de.trustpilot.com/reviews/67a0df3ceca6b9ee9a8ecf3b",
          rev_rating: 5,
          rev_source: "Trustpilot Bewertung"
        },
        {
          rev_name: "Sven",
          rev_text:"Unser Umzug lief wirklich perfekt: Schnell, problemlos und ohne Schäden. Es wurde wirklich auf alles geachtet. Auch das Team und der Kontakt waren immer freundlich, hilfsbereit und unkompliziert. Und zum Schluss all dies für einen sehr fairen Preis. Gerne wieder und vielen Dank für diesen tollen Umzug",
          rev_link: "https://maps.app.goo.gl/AXW74XymhfjZg7CH6",
          rev_rating: 5,
          rev_source: "Google Bewertung"
        },
      {
          rev_name: "Clemens Treml",
          rev_text:"Ein großes Lob und herzlicher Dank an Umzug Bayern! Die starken Männer haben meinen nicht ganz unkomplizierten Umzug aus dem 2.+3. OG ins 2.+3.OG mit zwei vollen LKWs perfekt gemeistert. Alle Mitarbeiter waren immer freundlich und haben Alles möglich gemacht (Geschirr einpacken, Schränke ab- und wieder aufbauen etc.). Es ist nichts kaputtgegangen und nichts wurde beschädigt und der ganze Umzug hat wie geplant an einem Tag geklappt. Ein Topfirma, die ich nur empfehlen kann!",
          rev_link: "https://de.trustpilot.com/reviews/67a1df5f004ddd3073dd3a6e",
          rev_rating: 5,
          rev_source: "Trustpilot Bewertung"
        },
      {
          rev_name: "Yvonne Kirchner",
          rev_text:"Ein großes Lob an Umzug-Bayern! Innerhalb von 4,5 Stunden wurde mein Haus in eine Wohnung (2.+3. Stock) umgezogen. Alles ging super schnell, sehr sehr gewissenhaft und unglaublich freundlich! Der Kontakt vorab per Mail und Telefon war sehr unkompliziert und angenehm und der Preis unschlagbar! Absolut empfehlenswert!!!",
          rev_link: "https://de.trustpilot.com/reviews/676136413f6524c23bddb623",
          rev_rating: 5,
          rev_source: "Trustpilot Bewertung"
        },
        {
          rev_name: "Peter Küdde",
          rev_text:"Es war genau die richtige Entscheidung von Umzug-Bayern meinen Umzug machen zu lassen. Bin schon mehrfach mit Unterstützung umgezogen, allerdings noch nie so einfach und gut. Das Super Team hat für mich den besten Umzug gemacht. Am Morgen pünktlich gekommen, zügig die Fahrzeuge beladen und dabei jede Sorgfalt sehen lassen, die man erwarten kann. Teilweise Abbau meiner Möbel, ruhig und professionell. Das Ausladen lief gleich ruhig und professionell. Der Aufbau der Möbel war besser als vom Möbelhaus. Hut ab. Abrechnung war absolut fair und korrekt. Da gab es nichts auszusetzen. Zusatzkosten für Verpackungsmaterial sind genau im Rahmen. Nochmals herzlichen Dank für das tolle Team und den guten Service, kann man nur weiter empfehlen!",
          rev_link: "https://g.co/kgs/JF8LpkS",
          rev_rating: 5,
          rev_source: "Google Bewertung"
        },
        {
          rev_name: "Andrea Baldus",
          rev_text:"Top-Team, hat sehr gut geklappt! Schneller Umzug, keine Beschädigungen, alle Möbel, Bilder und Gegenstände wurden optimal verpackt und vor Ort wieder entpackt. Preislich angemessen und keine Kostenüberraschung hinterher. Ich kann das Team nur weiterempfehlen.",
          rev_link: "https://de.trustpilot.com/reviews/67261019dcbfb5eb571b95b4",
          rev_rating: 5,
          rev_source: "Trustpilot Bewertung"
        },
        {
          rev_name: "Sylke Joos",
          rev_text:"Vom ersten Kontakt, Angebot einholen, bis zum Umzug, alles professionell, kompetent, pünktlich und höflich. Alle Möbel wurden sorgfältig verpackt. Es war ein Umzug vom EG in den 3.Stock. Trotz großer körperlicher Anstrengung, alles mit Sorgfalt und im angegebenen Zeitraum erledigt. Preis-Leistung = top. Ich bin sehr froh diese Profis beauftragt zu haben und bedanke mich nochmals.",
          rev_link: "https://g.co/kgs/q5TBQpk",
          rev_rating: 5,
          rev_source: "Google Bewertung"
        },
        {
          rev_name: "Gerd Bausch",
          rev_text:"Ein sehr professionelles Umzugsunternehmen! Kaum ein Mensch zieht gerne um. Aber wenn es sein muss, sollte man das Glück haben, als Umzugsunternehmen die Profis von Alexander Maier beauftragt zu haben. Der gesamte Umzug lief routiniert und in einer angenehmen Atmosphäre ab. Es ist absolut nichts kaputt gegangen. Ich kann Umzug Bayern jedem bestens empfehlen.",
          rev_link: "https://g.co/kgs/DFsqE3D",
          rev_rating: 5,
          rev_source: "Google Bewertung"
        },
        {
          rev_name: "Sophia S.",
          rev_text:"Ich kann dieses Umzugsunternehmen nur weiterempfehlen, und bin sehr zufrieden. Es waren sehr höfliche Möbelpacker, die sehr achtsam mit allem umgegangen sind, aber stark angepackt haben. Und das Preis-Leistungsverhältnis stimmt auch - immer gerne wieder!",
          rev_link: "https://g.co/kgs/fVhk4dZ",
          rev_rating: 5,
          rev_source: "Google Bewertung"
        },
        {
          rev_name: "Ramazan",
          rev_text:"Sehr zuverlässig, alles wie vorher angekündigt, Anzahl Personen sowie Uhrzeiten, Kosten, transparent und nachvollziehbar. Waren mit zwei Fahrzeugen Vorort. Wir können definitiv empfehlen.",
          rev_link: "https://www.my-hammer.de/auftragnehmer/umzug-bayern/bewertungen",
          rev_rating: 5,
          rev_source: "MyHammer Bewertung"
        },
        {
          rev_name: "Anonym",
          rev_text:"Alles hat absolut einwandfrei und reibungslos funktioniert. Das Team von Umzug Bayern war sehr freundlich, zuverlässig und professionell. Ich kann das Unternehmen vorbehaltlos weiterempfehlen und würde es jederzeit wieder beauftragen.",
          rev_link: "https://www.my-hammer.de/auftragnehmer/umzug-bayern/bewertungen",
          rev_rating: 5,
          rev_source: "MyHammer Bewertung"
        },
        {
          rev_name: "Anni",
          rev_text:"Sehr gutes Umzugsunternehmen mit super freundlichen und sehr fleißigen Mitarbeitern. Pünktlich um 8 Uhr ging es los, die Möbel wurden sorgfältig verpackt, die Lampen abgenommen und alles in die beiden Umzugswagen geladen. In der neuen Wohnung alles wieder dort hingestellt und aufgebaut wo es hin sollte und sogar die Lampen angebracht. Keine bösen Überraschungen, nix kaputt gegangen, kein Chaos beim Ausladen. Einfach Top und gutes  Preis-Leistungs Verhältnis. So wünscht man sich seinen Umzug. Vielen Dank und jeder Zeit wieder! :)",
          rev_link: "https://g.co/kgs/qj5Pqs",
          rev_rating: 5,
          rev_source: "Google Bewertung"
        },
        {
          rev_name: "Anonym",
          rev_text:"Top Umzug! Pünktlich, professionell, freundlich, schnell, keinerlei Schäden! 4 Personen Haushalt innerhalb eines Tages mit Möbel Ab- u Aufbau, WaMa mit Anschluss, Räder, Pflanzen, ca. 100 Kartons. Absolut fairer Preis! Würden wir jederzeit wieder buchen!",
          rev_link: "https://www.my-hammer.de/auftragnehmer/umzug-bayern/bewertungen",
          rev_rating: 5,
          rev_source: "MyHammer Bewertung"
        },
        {
          rev_name: "Kati B",
          rev_text:"Unser Umzug war zwar nur 5km entfernt, jedoch hatten wir auch spezielle und sehr schwere Möbel über mehrere Stockwerke zu transportieren. Bereits bei der Besichtigung hat der Chef in kürzester Zeit eine absolut realistische Einschätzung abgegeben und auch der Kostenvoranschlag war in kürzester Zeit da. Die Jungs inkl. dem Chef waren super pünktlich, freundlich, schnell und haben taktisch sehr geschickt gearbeitet. Es wurde mit allem sehr sorgfältig umgegangen und das Preis-Leistungs-Verhältnis ist einsame Spitze. Außerdem wurde uns kurzfristig noch beim Aufbau eines großen Schranks geholfen - Danke nochmal für alles. Meine absolute Weiterempfehlung und ich würde euch jederzeit wieder buchen!",
          rev_link: "https://g.co/kgs/LSfVzy",
          rev_rating: 5,
          rev_source: "Google Bewertung"
        },
        {
          rev_name: "Anonym",
          rev_text:"Eine perfekte Abwicklung der Entrümpelung unseres Hauses. Pünktlich, ordentlich, schnell und sehr nett. Kann ich nur empfehlen.",
          rev_link: "https://umzug.check24.de/umzug/profil/raopam",
          rev_rating: 5,
          rev_source: "Check24 Bewertung"
        },
        {
          rev_name: "Olga Maier",
          rev_text:"Der Umzug selbst verlief reibungslos und stressfrei. Das Team von Firma Umzug Bayern kam pünktlich an und arbeitete schnell und effizient. Sie behandelten meine Möbel und persönlichen Gegenstände mit äußerster Sorgfalt und schätzten sie während des Transports. Besonders beeindruckt war ich von der Fähigkeit des Teams,mit unvorhergesehenen Problemen umzugehen. Als ich feststellen,dass mein neues Zuhause nicht genug Platz für einen großen Schrank hatte,fanden Sie sofort eine Lösung und boten mir verschiedene Optionen an. Alles in allem,kann ich Firma Umzug Bayern nur wärmstens empfehlen.",
          rev_link: "https://de.trustpilot.com/reviews/657ed20d670a96628fee35af",
          rev_rating: 5,
          rev_source: "Trustpilot Bewertung"
        },
        {
          rev_name: "Anonym",
          rev_text:"Der Umzug und die vorherige Angebotserstellung hat einwandfrei funktioniert! Bei der Angebotserstellung wurde sich Zeit genommen, mir alles ausführlich zu erklären. Die angegebene Zeitdauer und die zusätzlich verwendeten Verpackungsmaterialien wurden richtig eingeschätzt. Der Umzug selbst ist sehr sorgsam und gut strukturiert abgelaufen. Alle Möbel wurden sorgfältig abgebaut, verpackt, transportiert und wieder aufgebaut.",
          rev_link: "https://www.my-hammer.de/auftragnehmer/umzug-bayern/bewertungen",
          rev_rating: 5,
          rev_source: "MyHammer Bewertung"
        },
        {
          rev_name: "Olesya Kuzmenova",
          rev_text:"Ein kompetentes und sehr gut organisiertes Umzugsunternehmen. Ich bin sehr zufrieden. Das Preis-Leistungsverhältnis hat auch sehr gut gepasst. Kann ich nur weiterempfehlen.",
          rev_link: "https://g.co/kgs/JmSbVd",
          rev_rating: 5,
          rev_source: "Google Bewertung"
        },
        {
          rev_name: "Lea Winkelmann",
          rev_text:"Sehr zu empfehlen: Wir wurden von der ersten Anfrage bis zum Umzug sehr gut betreut. Schnelle Reaktion auf Fragen, absolut professionell und effizient. Alle Sachen wurden fachgerecht ab- und aufgebaut und verpackt, es ist nichts kaputt gegangen. Ich empfehle das Umzugsunternehmen uneingeschränkt weiter.",
          rev_link: "https://g.co/kgs/i8HRin",
          rev_rating: 5,
          rev_source: "Google Bewertung"
        },
        {
          rev_name: "D J",
          rev_text:"Umzug innerhalb München in den Münchner Landkreis. Beratung Professionalität. Möbel wurde fachgerecht eingepackt und transportiert. Es wurden keine Schäden verursacht. Sehr empathisch, professionelle und großartige Umsetzung. Kann ich nur blind empfehlen. Wir waren sehr zufrieden. Top Qualität und sehr gute empathische Umsetzung. Herzlichen Dank an dieses tolle Team.",
          rev_link: "https://g.co/kgs/VkDf8u",
          rev_rating: 5,
          rev_source: "Google Bewertung"
        },
        {
          rev_name: "B W",
          rev_text:"Absolute Empfehlung. Die gesamte Abwicklung des Umzugs war einwandfrei, professionell und ein faires Preis-Leistungs-Verhältnis. Die Mitarbeitenden haben schnell, behutsam und sauber gearbeitet. Es wurde an alles gedacht (Schutz des Bodens, Möbel...)",
          rev_link: "https://g.co/kgs/TqjSe9",
          rev_rating: 5,
          rev_source: "Google Bewertung"
        },
        {
          rev_name: "Arielle Arabie",
          rev_text:"Ich bin wie immer sehr zufrieden. Ich 6 mal mit der Firma Umzug Bayern und Diez Umzug, umgezogen. Ich kann nur sagen... top! Ich kann nur weiterempfehlen. Liebe Grüße aus Aschau Arielle",
          rev_link: "https://g.co/kgs/YxHBkn",
          rev_rating: 5,
          rev_source: "Google Bewertung"
        },
        {
          rev_name: "Julia",
          rev_text:"Die Firma Umzug Bayern hat den Umzug meiner Eltern - Ü 60 durchgeführt. Das war für meine Eltern eine stressige Situation, aber die Firma Umzug Bayern hat den Umzug sehr professionell gemeistert. Die Mitarbeiter haben vorrausschauend und durchdacht gearbeitet. Es ging alles zügig voran. Sie haben meinen Eltern sehr geholfen den Umzug stressfrei zu erleben. Es wurde alles sorgsam für den Transport verpackt, der Boden mit Vlies geschützt. Die Möbeln wurden flexibel nach Wunsch meiner Eltern montiert. Ähnelt einer Schreinerleistung. Auch die Lampen, Spiegeln und Bilder haben sie angebracht. Bei der Aufgabe sind die Arbeiter sehr geduldig und freundlich geblieben. Man merkt dieser Umzugsfirma die lange Erfahrung an. Ich kann die Firma Umzug Bayern - Alexander Maier Kleintransporte wärmstens weiter empfehlen! Vielen Dank noch mal.",
          rev_link: "https://g.co/kgs/WnQy7G",
          rev_rating: 5,
          rev_source: "Google Bewertung"
        },
        {
          rev_name: "Ksali Musik",
          rev_text:"Umzug innerhalb München. Beratung  Professionalität. Möbel wurde Fachgerecht eingepackt und Transportiert. Es wurden keine Schäden verursacht.  Nette Mitarbeiter,  würde ich weiter empfehlen.",
          rev_link: "https://g.co/kgs/hof6FN",
          rev_rating: 5,
          rev_source: "Google Bewertung"
        },
        {
          rev_name: "Wolfgang Hofstaller",
          rev_text:"Super die Jungs.  Pünktlich,  schnell  sehr professionell.  Unser Umzug Anfang des Jahres hat super geklappt. Auch der Preis passt. Absolut empfehlenswert.",
          rev_link: "https://g.co/kgs/LRmQ9y",
          rev_rating: 5,
          rev_source: "Google Bewertung"
        },
        {
          rev_name: "GEHI 7",
          rev_text:"Umzug innerhalb München inkl. Halteverbotszone Syper Team, kann nur weiter empfehlen.",
          rev_link: "https://g.co/kgs/2HNSBv",
          rev_rating: 5,
          rev_source: "Google Bewertung"
        },
        {
          rev_name: "Markus Hemm",
          rev_text: "Wir haben nun schon zum zweiten Mal unseren Umzug mit Umzug Bayern gemacht und können den Service und das Unternehmen uneingeschränkt empfehlen. Herr Maier und sein Team haben von der Auftragsannahme bis hin zur Auftragsabwicklung einen grandiosen und professionellen Job gemacht. Besonders hervorheben möchte ich Max und Ivan, die jeder Herausforderung gewachsen waren. Wir werden den Service gerne wieder wählen.",
          rev_link: "https://goo.gl/maps/VewuzK9UtwRWgJXT6",
          rev_rating: 5,
          rev_source: "Google Bewertung"
        },
        {
          rev_name: "Regina S.",
          rev_text: "Wir sind sehr zufrieden mit unserem Umzug und der ganzen Organisation. Schnelle Kommunikation, Freundlichkeit und super Preis-Leistung! Alle aus dem Team haben einen tollen und schnellen Job gemacht. Danke dafür! Es ist nichts kaputt gegangen und das Team ging mit viel Erfahrung und Vorsicht bei brüchigen Dingen ans Werk. Wir würden uns jederzeit wieder für dieses Team entscheiden.",
          rev_link: "https://de.trustpilot.com/review/www.umzug-bayern.com",
          rev_rating: 5,
          rev_source: "Trustpilot Bewertung"
        },
        {
          rev_name: "Natalia König",
          rev_text: "Ich war sehr zufrieden! Schnelle und unkomplizierte Kommunikation. Der Umzug konnte schon eine Woche nach dem ersten Telefonat umgesetzt werden. Alle Möbel wurden sorgsam eingepackt und aus dem 5.OG (ohne Aufzug) in die neue Wohnung, wieder 5.OG (ohne Aufzug) getragen. Alle blieben trotzdem gut gelaunt, entspannt und gingen möglichst effizient vor. Ich würde ,,Transporte Maier,, jederzeit wieder buchen!",
          rev_link: "https://goo.gl/maps/gTxVq2hDcjnx6tUd8",
          rev_rating: 5,
          rev_source: "Google Bewertung"
        },
        {
          rev_name: "Daniela Rappl",
          rev_text: "Ich kann Alexander Maier und sein Team zu 100% weiter empfehlen, denn heutzutage findet man leider viel zu selten derartige professionelle Unternehmen deren Leitspruch fair, pünktlich, preislich top, vertrauensvoll, freundlich, fleissig, sauber, ehrlich lautet! Die Firma Umzug Bayern erfüllt ALLE vorgenannten Eigenschaften bzw. Versprechen. Ich bin wirklich sehr dankbar, diese Firma beauftragt zu haben und würde es bei Bedarf jederzeit wieder tun. Vom ganzem Herzen Dankeschön!!!",
          rev_link: "https://goo.gl/maps/GAbbDAv9zcmEXEyz6",
          rev_rating: 5,
          rev_source: "Google Bewertung"
        },
        {
          rev_name: "Martin E.",
          rev_text: "Danke an Herrn Maier und sein Team für den tollen und stressfreien Umzug von Bayern in den hohen Norden! Super Service, schneller Besichtigungstermin, direkt danach ein Kostenvoranschlag zu einem guten Preis. Am Umzugstag pünktliche, ordentliche und extrem schnelle Arbeit. Sehr höfliche und kompetente Mitarbeiter. Der Möbelab- und Aufbau war super, meine Möbel und Kisten wurden sehr sorgfältig behandelt und es kam zu keinem Schaden! So muss ein gutes Umzugsunternehmen arbeiten. Eine ganz klare Empfehlung von mir!",
          rev_link: "https://goo.gl/maps/kog9e59cNYrqF6zR9",
          rev_rating: 5,
          rev_source: "Google Bewertung"
        },
        {
          rev_name: "Tania Torres",
          rev_text: "Kann man nur weiter empfehlen. Danke für diesen tollen Service. Sie waren super,mussten jedesmal in den 3stock steigen und wieder runter...unglaublich wie sie trotz allem so freundlich gelächelt haben.Wirsind sehr froh das wir so glück hatten. DANKE NOCHMAL nallen 4 Männer. Hut ab!",
          rev_link: "https://goo.gl/maps/HqxLt3k2AsgS7Xtf6",
          rev_rating: 5,
          rev_source: "Google Bewertung"
        },
        {
          rev_name: "Stephan",
          rev_text: "Wir haben Umzug Bayern über die App im Playstore gefunden und konnten die Firma direkt per Smartphone beauftragen. Das Beste: Es gab direkt ein Angebot mit Preisangabe vor der Beauftragung. Vielen Dank für die schnelle Hilfe!!!",
          rev_link: "https://de.trustpilot.com/review/www.umzug-bayern.com",
          rev_rating: 5,
          rev_source: "Trustpilot Bewertung"
        },
        {
          rev_name: "Matthias Hommer",
          rev_text: "Ich habe Umzug Bayern für mehrere Aktivitäten genutzt: Umzug nach Österreich, Umzug innerhalb Münchens und Sperrmüllentsorgung. Ich war sehr zufrieden. Das Team ist sehr professionell, pünktlich, arbeitet zügig, transportiert auch schwere Möbel durch steile und enge Räume und baut auch hochwertige Möbel passgenau ab und wieder auf. Interaktion, Angebotserstellung und Terminfindung geht sehr schnell und die finalen Kosten entsprachen auch dem Angebotspreis. Ich kann Umzug Bayern daher absolut weiterempfehlen.",
          rev_link: "https://goo.gl/maps/CKQiZiiwLrst9wPh8",
          rev_rating: 5,
          rev_source: "Google Bewertung"
        },
        {
          rev_name: "Augustus R.",
          rev_text: "Ich war sehr zufrieden mit dem Umzugsunternehmen. Alles bestens. Sehr gutes Preis-Leistungsverhältnis.",
          rev_link: "https://de.trustpilot.com/review/www.umzug-bayern.com",
          rev_rating: 5,
          rev_source: "Trustpilot Bewertung"
        },
      ]
    };
  },
  computed: {
    numOfDots: function() {
      if(this.reviews.length > 0) {
        return this.reviews.length / this.numOfVisibleReviews
      }
      else {
        return 1
      }
    },
    selectedReview: function () {
      return this.reviews[this.selectedReviewIndex]
    },
    selectedReviewSecond: function () {
      var index = this.selectedReviewIndex
      if(index < (this.reviews.length - 1)) {
        index = index + 1
      } else {
        index = 0
      }
      return this.reviews[index]
    }
  },
  methods: {
    dotClick: function(index) {
      this.selectedReviewIndex = index
    },
    leftClick: function() {
      this.hide()
      setTimeout(() => {
        if(this.selectedReviewIndex > 0) {
          this.selectedReviewIndex = this.selectedReviewIndex - 1
        } else {
          this.selectedReviewIndex = this.reviews.length - 1
        }
      }, 500)
      setTimeout(() => {
        this.reveal()
      }, 500)
    },
    rightClick: function() {
      this.hide()
      setTimeout(() => {
        if(this.selectedReviewIndex < (this.reviews.length - 1)) {
          this.selectedReviewIndex = this.selectedReviewIndex + 1
        } else {
          this.selectedReviewIndex = 0
        }
      }, 500)
      setTimeout(() => {
        this.reveal()
      }, 500)
    },
    reveal: () => {
      const reveals = document.querySelectorAll('.revealreview')
      for (let i = 0; i < reveals.length; i++) {
          reveals[i].classList.add('active')
      }
    },
    hide: () => {
      const reveals = document.querySelectorAll('.revealreview')
      for (let i = 0; i < reveals.length; i++) {
          reveals[i].classList.remove('active')
      }
    }
  },
  mounted: function() {
    var min = 0
    var max = (this.reviews.length - 1)
    this.selectedReviewIndex = Math.floor(Math.random() * (max - min + 1) + min)
    setInterval(() => {
      this.rightClick()
    }, 7000)
  }
}
</script>
<style scoped>
.revealreview {
  position: relative;
  transform: translateY(0);
  opacity: 0;
  transition: 0.5s all ease;
}

.revealreview.active {
  transform: translateY(0);
  opacity: 1;
}

</style>
